module.exports = __webpack_public_path__ + "static/media/sky.822ff126.svg";